export default "__VITE_ASSET__BRlhyrzU__"